import React, { useEffect } from "react";
import "./Home.css";
import NavbarCont from "../Navbar/NavbarCont";
import CarouselListCont from "../Carousel/CarouselListCont";
import { useDBContext } from "../Context/DBcontext";
import Top from "./Top/Top";
import TopSection from "./Top-Section/TopSection";
import Footer from "../Footer/Footer";
import Twitter from "../Widgets/Twitter";
import InstagramFeed from "../Widgets/InstagramFeed";
import Mid from "./Mid/Mid";
import InstagramGallery from "../Widgets/InstagramGallery";
import TiendaProducts from "../Tiendanube/TiendaProducts";
import { Link } from "react-router-dom";

export default function Home() {
  const { articles, getArticles, banners, getBanners } = useDBContext();

  useEffect(() => {
    getArticles()
    getBanners()
  }, []);

  let magazineBanner = banners ? banners.find(e => e.id === "launch") : null
  // let adBanner = banners ? banners.find(e => e.id === "launch") : null

  // Función para ordenar artículos por fecha de forma descendente
  function getMostRecentArticles(articles, position, limit) {
    return articles
      .filter((article) => article.position === position) // Filtra por la posición
      .sort((a, b) => new Date(b.date) - new Date(a.date)) // Ordena por fecha de forma descendente
      .slice(0, limit); // Selecciona los primeros artículos hasta el límite especificado
  }

  // Obtener los 4 artículos más recientes para "arriba"
  let topArticles = getMostRecentArticles(
    articles.filter((e) => e.enabled === true),
    "portada",
    4
  );

  // Obtener los 4 artículos más recientes para "medio"
  let midArticles = getMostRecentArticles(
    articles.filter((e) => e.enabled === true),
    "medio",
    3
  );

  // Obtener los 6 artículos más recientes para "abajo"
  let lowArticles = getMostRecentArticles(
    articles.filter((e) => e.enabled === true),
    "abajo",
    6
  );

  let coverArticles = articles.filter((e) => e.category === "Nota de tapa");
  let historyArticles = articles.filter((e) => e.category === "Historia");
  let textosMillonariosArticles = articles.filter(
    (e) => e.category === "Textos millonarios"
  );
  let historiasMonumentalesArticles = articles.filter(
    (e) => e.category === "Historias monumentales"
  );
  let tiendaArticles = articles.filter((e) => e.category === "Tienda");

  const exchangeCodeForToken = async (code) => {
    const response = await fetch(
      "https://api.facebook.com/oauth/access_token",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          client_id: "1317574072553994",
          client_secret: "7bcfd6595f4379bce66782dbbf3a5076",
          grant_type: "authorization_code",
          redirect_uri:
            "https://66abdd099e097e44c2ed7b60--fastidious-maamoul-871950.netlify.app/",
          code: "EAANRbZCYTeIkBOx4411TrV0LKciH1liZAX2hwfz2sZBX3xKxIZBQeZAUsVKxGOBlbisXhPfMFfclXwUxR1mYrzqrofjFrwOMbwAEZA6GLpO2n6HZB0lYvPFgNKh2Ck56tc263ZCvGS2kVNYRYK2W6PTzsjQshRZCoefBhBll7M4IJbTv7Cfinv5jBSOv1ZCjkKt2lgGyKDZBsOC6fqls2i20v9gkuqlmDA45A0ZBfUlzVYZAu0h7EC0bdKlsoisNJUWwZD",
        }),
      }
    );

    const data = await response.json();

    return data.access_token;
  };

  const getLongLivedToken = async (shortLivedToken) => {
    const response = await fetch(`https://graph.instagram.com/access_token
      ?grant_type=ig_exchange_token
      &client_secret=7bcfd6595f4379bce66782dbbf3a5076
      &access_token=${shortLivedToken}`);

    const data = await response.json();
    return data.access_token;
  };

  return (
    <div className="home-cont">
      <Link to="/article/gZG4OYADsvRAJ3mv1Ste" className="suscribenavcont">
        Suscribite y recibí la <b>Revista 1986</b> sin moverte de tu casa.
      </Link>
      <NavbarCont
        articles={articles}
        coverArticles={coverArticles}
        historyArticles={historyArticles}
        textosMillonariosArticles={textosMillonariosArticles}
        historiasMonumentalesArticles={historiasMonumentalesArticles}
        home={true}
      />
      <section className="home-articles-carousel">
        <CarouselListCont gallery={topArticles} autoChange={true} bar={true} />
      </section>

      <TopSection data={magazineBanner} />

      <section className="home-articles-section-1">
        <Top articles={midArticles} />
      </section>

      {/* <div className='banner-top'>
        Banner tienda
      </div> */}

      {/* <TiendaProducts /> */}

      <section className="middle-cont">
        <div className="middle-cont-news">
          <p className="middle-cont-news-title">
            {" "}
            <img
              width="18"
              height="18"
              src="https://img.icons8.com/ios-filled/50/cd3a3a/magazine.png"
              alt="read"
            />{" "}
            River para leer
          </p>
          <Mid articles={lowArticles} />
          <Link onClick={() => {
            window.scrollTo(0, 0)
          }} to="/articulos/all" className="buttonbyn">VER MÁS</Link>
        </div>

        <div className="middle-cont-instagram">
          <img
            className="instagram-icon"
            src="https://img.icons8.com/ios-filled/100/instagram-new.png"
            alt="instagram"
          />
          <InstagramFeed />
        </div>
      </section>
    {/*   <div className="banner-top">Banner</div>*/}

      {/* <iframe src='https://www.juicer.io/api/feeds/revista1986/iframe' frameborder='0' className='juicer'>      <p className='juicer2'></p></iframe> */}

      {/* <InstagramGallery
        accessToken="IGQWRNOGZAkYzNvUjRkNFFPRXo2aW43cDJfYTQxLWFybDhHMEZAURXlwb3ZAVNjdiQ1lkYXhaWFlGYzBYZAE1sUTVSbDJCVFI1R0pzZAkM0d3d0RkRxS0JlTnVVeU02eFROM2NqQ3N3a0xlZAnhYdwZDZD"
        count={9}
        pagination={true}
      /> */}

      <Footer />

      {/* <InstagramAuth />   2/8 - cada 60 días  */}
{/* 
      <button className="buttonbyn" onClick={exchangeCodeForToken}>get token</button> */}
    </div>
  );
}
